module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('h1', [_vm._v("About Xolas TMS")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Version " + _vm._s(_vm.ver)), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("For " + _vm._s(_vm.clientName))]), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "300px",
      "height": "auto"
    },
    attrs: {
      "src": _vm.logo
    }
  }), _c('br'), _vm._v(" "), _c('p', [_vm._v("How to Use to the system "), _c('router-link', {
    attrs: {
      "to": "help"
    }
  }, [_vm._v("User Guide")])], 1), _vm._v(" "), _c('p', [_vm._v("Website "), _c('a', {
    attrs: {
      "href": "https://www.xolas.io",
      "target": "_blank"
    }
  }, [_vm._v("xolas.io")])]), _vm._v(" "), _c('p', [_vm._v("Support "), _c('a', {
    attrs: {
      "href": "https://support.xolas.io",
      "target": "_blank"
    }
  }, [_vm._v("support.xolas.io")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67c6c8b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/About.vue
// module id = 1535
// module chunks = 0